import { forwardRef, type Ref, type SVGProps } from "react";

function SvgEye(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#eye_svg__a)">
        <path
          fill="currentColor"
          d="M15.457 7.798c-.022-.05-.551-1.224-1.728-2.401C12.16 3.829 10.18 3 8 3s-4.16.829-5.729 2.397C1.094 6.574.562 7.75.543 7.797a.5.5 0 0 0 0 .407c.022.05.551 1.223 1.728 2.4C3.84 12.17 5.82 13 8 13s4.16-.829 5.729-2.396c1.177-1.177 1.706-2.35 1.728-2.4a.5.5 0 0 0 0-.407M8 12c-1.924 0-3.604-.7-4.996-2.078A8.3 8.3 0 0 1 1.562 8a8.3 8.3 0 0 1 1.442-1.922C4.396 4.7 6.076 4 8 4s3.604.7 4.996 2.078A8.3 8.3 0 0 1 14.44 8c-.451.841-2.414 4-6.441 4m0-7a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
        />
      </g>
      <defs>
        <clipPath id="eye_svg__a">
          <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgEye);
export default ForwardRef;
